import { useModal } from 'components/common/ModalLayout';
import { useEffect } from 'react';
import hubLayout from 'styles/css/hubLayout.module.css';

export function NotFound() {
    
    return (
        <>
            <div className={`${hubLayout.cnt_box}`} style={{overflowY: "auto"}}>
                <div className={`${hubLayout.acc__cnt}`}>
                    <div className={`${hubLayout.sec_title} ${hubLayout.fixed_title}`}>
                        <h2>404 Not Found</h2>
                        <h3>해당 페이지를 찾을 수 없습니다.</h3>
                    </div>
                </div>
            </div>
        </>
    );
}

export function NotFoundUserWebView() {   
    
    return (
        <>
            <div className={`${hubLayout.cnt_box}`} style={{overflowY: "auto"}}>
                <div className={`${hubLayout.acc__cnt}`}>
                    <div className={`${hubLayout.sec_title} ${hubLayout.fixed_title}`}>
                        <h2>해당 페이지를 찾을 수 없습니다.</h2>
                    </div>
                </div>
            </div>
        </>
    );
}

export function BadRequestUserWebView() {
    const redirect_code = new URLSearchParams(window.location.search).get('redirect_code'); 
    const redirect_msg = new URLSearchParams(window.location.search).get('redirect_msg') || ''; 
    const { showModal } = useModal();

    useEffect(() => {
        // NicePass 인증 결과 처리
        if (redirect_code) {
          showModal("alert", redirect_msg);
        }
    }, []);

    return (
        <>
            <div className={`${hubLayout.cnt_box}`} style={{overflowY: "auto"}}>
                <div className={`${hubLayout.acc__cnt}`}>
                    <div className={`${hubLayout.sec_title} ${hubLayout.fixed_title}`}>
                        <h2>잘못된 요청입니다.</h2>
                    </div>
                </div>
            </div>
        </>
    );
}